import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'grabbill-client-email-stat',
  templateUrl: './email-stat.component.html',
  styleUrls: ['./email-stat.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailStatComponent {
  @Input()
  emailTotal: number = 0;

  @Input()
  emailSent: number = 0;

  @Input()
  emailOpened: number = 0;

  @Input()
  emailBounced: number = 0;

  @Input()
  emailUnsubscribed: number = 0;

  @Input()
  emailSkip: number = 0;

  @Input()
  emailAcknowledge: number = 0;

  // Which stat box's filter is currently applied by the parent (or null/
  // undefined for none) - drives the `.active` highlight below.
  @Input()
  activeFilter: string | null = null;

  // True when the Record Status / Email Status dropdown filters (owned by
  // the parent) are narrowing the table - so the Total box only claims
  // "showing everything" when that's actually true, not just when no stat
  // box happens to be clicked.
  @Input()
  hasOtherFiltersActive: boolean = false;

  // Emits the clicked box's key ('sent'/'opened'/'bounced'/'unsubscribed'/
  // 'skip'/'acknowledge'), or null for the Total box. Toggle/switch logic
  // lives in the parent - this component just reports what was clicked.
  @Output()
  filterChange = new EventEmitter<string | null>();
}
